import React, {useEffect} from 'react';

function Main(props) {
    
    useEffect(()=>{
        window.addEventListener('scroll',printScroll);
        return ()=>{
            window.removeEventListener('scroll',printScroll);
        }
    }, []);
    
    let y = 0;
    const printScroll=()=>{
        y = window.scrollY;
        const mainAfter = document.querySelector('.main-after');
        mainAfter.style.backdropFilter = `blur(${y/120}px)`;
    }
    
    return (
        <>
            <section id="main" className="relative" style={props.bg}>
                <div className="wrap relative h-1/2 sticky top-16 z-40">
                    <div className="typo absolute z-40 left-0">
                        <h1 className="text-6xl leading-10">
                            <span className="text-xl">WEB FRONTEND</span>
                            <br />
                            PORTFOLIO
                        </h1>
                        <div className="flex justify-between text-xl mt-4 items-center">
                            <span>개인포트폴리오 프로젝트</span>
                            <span className="block bg-neutral-700 w-20 h-0.5"></span>
                            <span>안종현</span>
                        </div>
                    </div>
                    <svg viewBox="0 0 140 49" fill="none" xmlns="http://www.w3.org/2000/svg" className="absolute z-40 left-0 bottom-8 w-24">
                        <path d="M22.2013 7.78866C10.0983 7.78866 -0.0370241 16.3202 0.000101672 27.9474C-0.0370241 39.499 10.0983 47.9928 22.2013 47.9551C34.4528 47.9928 44.5882 39.499 44.6253 27.9474C44.5882 16.3202 34.4528 7.78866 22.2013 7.78866ZM11.2121 27.9474C11.175 21.6808 16.1127 18.17 22.2013 18.2078C28.3642 18.17 33.0792 21.6808 33.1163 27.9474C33.0792 34.1762 28.3642 37.9512 22.2013 37.9135C16.1127 37.9512 11.175 34.1762 11.2121 27.9474Z" fill="#a5f3fc"/>
                        <path d="M75.606 17.8303V17.7548H92.3869V8.01516H47.5389V17.7548H63.6515V17.8303C63.6515 27.1169 59.1964 36.0259 44.7916 38.9705L50.212 48.2571C59.9018 45.8788 66.139 40.7825 69.6288 34.0252C73.0815 40.7825 79.3186 45.8788 89.0456 48.2571L94.466 38.9705C80.024 36.0259 75.5689 27.1169 75.606 17.8303Z" fill="#a5f3fc"/>
                        <path d="M140 8.07858H123.368V0H111.487V8.07858H94.3353V17.8937H140V8.07858ZM98.6419 34.8059C98.6419 43.1487 106.513 49 117.279 49C128.12 49 136.065 43.1487 136.139 34.8059C136.065 26.614 128.12 20.6495 117.279 20.6872C106.513 20.6495 98.6419 26.614 98.6419 34.8059ZM110.819 34.8059C110.819 31.8991 113.566 30.7666 117.279 30.7288C121.066 30.7666 123.776 31.8991 123.813 34.8059C123.776 37.8636 121.066 38.9962 117.279 39.0339C113.566 38.9962 110.819 37.8636 110.819 34.8059Z" fill="#a5f3fc"/>
                    </svg>
                </div>
                <div className="main-after absolute inset-0 bg-white/10"></div>
            </section>
        </>
    );
}

export default Main;